import { render, staticRenderFns } from "./AudioFTPPage.vue?vue&type=template&id=2b2343a9&"
import script from "./AudioFTPPage.vue?vue&type=script&lang=ts&"
export * from "./AudioFTPPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports